import { jsxs as o, jsx as n } from "react/jsx-runtime";
import { c as _ } from "../../../../clsx-OuTLNxxd.js";
import { forwardRef as T } from "react";
import { I as U } from "../../../../icon-DtMxVF3r.js";
import "../../icon/iconsList.js";
import { useInput as A } from "./input.hook.js";
import { INPUT_STATUS as t, ICONS_STATUS as k } from "./input.type.js";
const z = "_input_jkm2r_29", B = "_filled_jkm2r_47", O = "_error_jkm2r_151", P = "_counter_jkm2r_171", r = {
  input: z,
  "group-label": "_group-label_jkm2r_29",
  filled: B,
  "is-error": "_is-error_jkm2r_50",
  "is-success": "_is-success_jkm2r_53",
  "is-warning": "_is-warning_jkm2r_56",
  "helper-text": "_helper-text_jkm2r_59",
  "is-disabled": "_is-disabled_jkm2r_86",
  "is-full-width": "_is-full-width_jkm2r_101",
  "container-counter-icon": "_container-counter-icon_jkm2r_145",
  error: O,
  "container-icon": "_container-icon_jkm2r_154",
  counter: P,
  "dialog-overlay-show": "_dialog-overlay-show_jkm2r_1",
  "dialog-content-show": "_dialog-content-show_jkm2r_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_jkm2r_1"
}, R = T(
  ({
    className: N,
    type: g = "text",
    value: c,
    message: d,
    status: i,
    placeholder: w,
    onChange: f,
    onBlur: a,
    disabled: s,
    label: l,
    helperText: p,
    name: u,
    isFullWidth: I,
    defaultValue: e,
    id: S,
    optionalMessage: h,
    maxLength: m,
    ...v
  }, x) => {
    const {
      valueCounter: j,
      handleBlur: b,
      handleChange: y
    } = A(
      c == null ? void 0 : c.toString(),
      e == null ? void 0 : e.toString(),
      f,
      a ? () => a({}) : void 0
    ), C = _(
      r.input,
      i && r[t[i]],
      s && r["is-disabled"],
      I && r["is-full-width"],
      N
    );
    return /* @__PURE__ */ o("div", { className: C, children: [
      /* @__PURE__ */ o("div", { className: r["group-label"], children: [
        /* @__PURE__ */ o("div", { children: [
          l && /* @__PURE__ */ n("label", { className: _(i && r[i]), children: l }),
          h && /* @__PURE__ */ n("span", { children: h })
        ] }),
        p && /* @__PURE__ */ n("div", { className: r["helper-text"], children: p })
      ] }),
      /* @__PURE__ */ n(
        "input",
        {
          id: S,
          ref: x,
          value: c,
          className: _(i && !s && r[t[i]]),
          type: g,
          placeholder: w,
          onChange: y,
          onBlur: b,
          name: u,
          defaultValue: e,
          "aria-label": l,
          ...v
        }
      ),
      /* @__PURE__ */ o("div", { className: r["container-counter-icon"], children: [
        d && i && !s && /* @__PURE__ */ o("div", { className: r["container-icon"], children: [
          /* @__PURE__ */ n(U, { name: k[i].name, size: "medium", color: k[i].color }),
          /* @__PURE__ */ n("span", { className: r[t[i]], children: d })
        ] }),
        m && /* @__PURE__ */ o("div", { className: _(r.counter, j > m && r.error), children: [
          j,
          "/",
          m
        ] })
      ] })
    ] });
  }
);
R.displayName = "Input";
export {
  R as Input
};
